import { Outlet } from 'react-router';

import { useCompanyStore } from '@/stores/company.store';

/**
 * The routed screen, remounted whenever the tenant changes.
 *
 * Clearing the query cache and the filter store is not enough on its own,
 * because a switch does not necessarily change the route: switching while
 * already on the planner navigates to the page it is already on, which React
 * Router treats as a no-op, so nothing unmounts.
 *
 * That matters because screens hold state a cache clear cannot reach. Today
 * and the Planner both pick their default branch behind a `useRef` that fires
 * once per mount; a screen that survives the switch keeps that ref, and with
 * the filter store just cleared it settles on no branch at all rather than the
 * new tenant's own. Open forms and local component state have the same
 * problem.
 *
 * Keyed on the scope rather than the company itself: the company changes
 * during render, while the teardown runs afterwards in an effect, so keying on
 * it would remount the screen against a cache that is still being emptied.
 * `beginNewScope` fires once the previous tenant is really gone — the
 * guarantee the old full-page reload gave for free.
 */
export function CompanyScopedOutlet() {
  const scopeEpoch = useCompanyStore(state => state.scopeEpoch);

  return <Outlet key={scopeEpoch} />;
}
